import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import React from "react";

const RazorpayOrderDetailsTable = ({
  razorpayorderdetails,
  data,
  perpage,
  currentPage,
  tab,
}) => {
  return (
    <>
      <TableBody>
        {razorpayorderdetails
          .slice((currentPage - 1) * perpage, currentPage * perpage)
          .map((data, index) => (
            <TableRow key={data.id}>
              <TableCell className="text-sm text-center">
                {(currentPage - 1) * perpage + index + 1}
              </TableCell>

              <TableCell className="text-sm text-center">{data.id}</TableCell>

              <TableCell className="text-sm text-center">
                {data.entity}
              </TableCell>

              <TableCell className="text-sm text-center">
                {data.amount}
              </TableCell>

              <TableCell className="text-sm text-center">
                {data.amount_paid}
              </TableCell>

              <TableCell className="text-sm text-center">
                {data.amount_due}
              </TableCell>

              <TableCell className="text-sm text-center">
                {data.currency}
              </TableCell>

              <TableCell className="text-sm text-center">
                {data.receipt}
              </TableCell>

              <TableCell className="text-sm text-center">
                {data.offer_id}
              </TableCell>

              <TableCell>
                <span
                  className={
                    `text-sm px-2 py-1 rounded-md 
                    ${
                      data.status === "paid"
                        ? "text-green-500"
                        : data.status === "created"
                        ? "text-purple-500"
                        : data.status === "attempted"
                        ? "text-red-500"
                        : "text-gray-500"
                    }` // Default color if status is unknown
                  }
                >
                  {data.status}
                </span>
              </TableCell>
              <TableCell className="text-sm text-center">
                {data.attempts}
              </TableCell>
              
              <TableCell>
                <span className="text-sm">
                  {new Date(data.created_at * 1000).toLocaleString("en-US", {
                    weekday: "short", // Short weekday (e.g., "Sat")
                    year: "numeric", // Full year
                    month: "short", // Short month (e.g., "Aug")
                    day: "numeric", // Day of the month
                    hour: "2-digit", // Hour in 2-digit format
                    minute: "2-digit", // Minute in 2-digit format
                    hour12: true, // 12-hour format
                  })}
                </span>
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </>
  );
};

export default RazorpayOrderDetailsTable;
